import LocomotiveScroll from "locomotive-scroll";
const locomotiveInit = () => {
  const scrollContainer = document.querySelector("[data-scroll-container]");

  const scroll = new LocomotiveScroll({
    el: scrollContainer,
    smooth: true,
    direction: "vertical",
    offset: "30%",
    class: "visible",
    smoothSticky: true,
    smartphone: {
      smooth: true,
    },
    tablet: {
      smooth: true,
    },
  });

  setTimeout(() => {
    scroll.update();
  }, 5000);


  let lastScrollY = 0;

  scroll.on('scroll', (obj) => {
      const nav = document.querySelector('.header');
      const currentScrollY = obj.scroll.y; 
      
      if (currentScrollY > lastScrollY && currentScrollY > 50) {
          nav.classList.add('hide'); 
      } else {
          nav.classList.remove('hide');
      }
    
      lastScrollY = currentScrollY;
  });

  return scroll;
};
export default locomotiveInit;
